export interface RealTimeFlightUpdateBasePayload {
    ArrivalAirportIata: String;
    ArrivalCityName: String;
    FlightNumber: String;
    DepartureTimeUtc: String;
    InternetMessageId: String;
}

export type RealTimeFlightDelayPayload = RealTimeFlightUpdateBasePayload & {
    Scenario: RealTimeFlightUpdateType.DepartureDelayed;
    UpdatedDepartureTimeUtc: String;
};

export type RealTimeFlightCancelPayload = RealTimeFlightUpdateBasePayload & {
    Scenario: RealTimeFlightUpdateType.Cancelled;
};

export enum RealTimeFlightUpdateType {
    DepartureDelayed = 'DepartureDelayed',
    Cancelled = 'Cancelled',
}
